import React from 'react';
import { VStack, Text, HStack } from '@skin-seoul/design-system';
import LucideIcon from '@/components/ui/LucideIcon';
import LegendItem from './components/LegendItem';
import BarChart from './components/BarChart';
import IngredientRatingsModal from './components/IngredientRatingsModal';
import { useProductService } from '@skin-seoul/service';
import { overlay } from 'overlay-kit';
import SectionContainer from '../../components/SectionContainer';
const IngredientRatingsSection = ({
  productId
}: {
  productId: string;
}) => {
  const {
    useGetProductMeta
  } = useProductService();
  const {
    data: productMeta
  } = useGetProductMeta({
    productId
  });
  const {
    starIngredient,
    sensitiveIngredient
  } = productMeta.taxonomies;
  const handleViewAll = () => {
    overlay.open(({
      isOpen,
      close
    }) => <IngredientRatingsModal isOpen={isOpen} onClose={close} starIngredients={starIngredient} />);
  };
  const ratingCounts = {
    great: 0,
    good: 0,
    acceptable: 0,
    sensitive: 0
  };
  starIngredient.map(ingredient => {
    const riskNumber = Number(ingredient.risk);
    if (riskNumber <= 2) {
      ratingCounts.great++;
    } else if (riskNumber <= 4) {
      ratingCounts.good++;
    } else if (riskNumber <= 6) {
      ratingCounts.acceptable++;
    } else {
      ratingCounts.sensitive++;
    }
  });
  sensitiveIngredient.map(ingredient => {
    const riskNumber = Number(ingredient.risk);
    if (riskNumber <= 2) {
      ratingCounts.great++;
    } else if (riskNumber <= 4) {
      ratingCounts.good++;
    } else if (riskNumber <= 6) {
      ratingCounts.acceptable++;
    } else {
      ratingCounts.sensitive++;
    }
  });
  const ratingsData = [{
    key: 'great',
    value: ratingCounts.great,
    color: 'primary.400',
    textColor: 'white',
    label: 'Great'
  }, {
    key: 'good',
    value: ratingCounts.good,
    color: 'primary.200',
    textColor: 'white',
    label: 'Good'
  }, {
    key: 'acceptable',
    value: ratingCounts.acceptable,
    color: 'primary.50',
    textColor: 'neutral.300',
    label: 'Acceptable'
  }, {
    key: 'sensitive',
    value: ratingCounts.sensitive,
    color: 'error.300',
    textColor: 'white',
    label: 'Sensitive'
  }];
  const totalIngredientsCount = starIngredient.length + sensitiveIngredient.length;
  if (!totalIngredientsCount) {
    return null;
  }
  return <SectionContainer headerTitle="Ingredients Breakdown" headerRightContent={<HStack gap={1} alignItems="center" justifyContent="flex-end" cursor="pointer" onClick={handleViewAll}>
          <Text textStyle={{
      base: 'label.small',
      tablet: 'label.medium'
    }} fontWeight="normal" color="neutral.600" textAlign="left" whiteSpace="nowrap">
            View all ({totalIngredientsCount})
          </Text>
          <LucideIcon name="ChevronRight" size={{
      base: 'md',
      tablet: 'lg'
    }} color="neutral.600" />
        </HStack>} data-sentry-element="SectionContainer" data-sentry-component="IngredientRatingsSection" data-sentry-source-file="IngredientRatingsSection.tsx">
      <VStack gap={{
      base: 2,
      tablet: 4
    }} width="100%" alignItems="stretch" data-sentry-element="VStack" data-sentry-source-file="IngredientRatingsSection.tsx">
        <BarChart ratings={ratingsData} data-sentry-element="BarChart" data-sentry-source-file="IngredientRatingsSection.tsx" />

        <HStack gap="21px" alignItems="center" paddingX="2px" width="100%" justifyContent={{
        base: 'flex-start',
        tablet: 'center'
      }} data-sentry-element="HStack" data-sentry-source-file="IngredientRatingsSection.tsx">
          {ratingsData.map(rating => <LegendItem key={rating.key} color={rating.color} label={rating.label} />)}
        </HStack>
      </VStack>
    </SectionContainer>;
};
export default IngredientRatingsSection;